import { render } from "./Thinking1.vue?vue&type=template&id=4ad4d7fd"
import script from "./Thinking1.vue?vue&type=script&lang=js"
export * from "./Thinking1.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__